export const fetchData = async ({apiUrl}) => {
  try {
    const url = new URL(apiUrl, window.Site.sportDomain);

    const response = await fetch(url.href);
    const data = await response.json() || null;

    if (!response.ok) {
      const error = (data && data.message) || response.status;

      console.error(error);
      return error;
    }
    return data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
